<div class="profile-edit-container">
   <div class="edit-form-holder py-1 my-3 shadow">
      <form
        (ngSubmit)="onUpdateProfile()"
        [formGroup]="updateProfileForm"
        class="my-3"
      >
        <div class="row">
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
            <div class="profile-img-blk" >
              <img src="{{ profilePicPath }}" onerror="this.src='./assets/img/dummy-photo.png';"  class="img-fluid rounded-circle"
              alt="profile_img"/>
              <i class="mi mi-add-a-photo add-photo"></i>
              <input type="file" class="upload-container"
              id="file"
              (change)="handleFileInput($event.target.files)"> 
              <p class="text-center profile-pic-name">{{selectedImageName}}</p>
            </div>
            
          </div>
          <div class="col-lg-9 col-md-9 col-sm-9 col-xs-12">
            <h5 class="content-label-each text-capitalize text-start mb-4" translate>
            pages.newRetailer.personalInformation
        </h5>
        <div class="content-details-blk px-0">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div class="row g-0">
                <div
                  class="col-lg-5 col-md-5 col-sm-5 col-xs-12 align-self-center"
                >
                  <h4 class="form-item-label" translate>
                    pages.newRetailer.firstName<span class="required">*</span>
                  </h4>
                </div>
                <div
                  class="col-lg-7 col-md-7 col-sm-7 col-xs-12 align-self-center"
                >
                  <div class="form-item-input">
                    <mat-form-field appearance="outline">
                      <input
                        matInput
                        type="text"
                        placeholder="{{ 'pages.placeholders.Enterfirstname' | translate }}"
                        formControlName="firstName"
                      />
                    </mat-form-field>
                    <div *ngIf="f.firstName.touched && f.firstName.invalid">
                      <div *ngIf="f.firstName.errors.required">
                        <mat-hint class="text-danger ms-2">
                          <span translate>pages.newRetailer.firstnameisrequired</span></mat-hint
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div class="row g-0">
                <div
                  class="col-lg-5 col-md-5 col-sm-5 col-xs-12 align-self-center"
                >
                  <h4 class="form-item-label" translate>
                    pages.newRetailer.lastName<span class="required">*</span>
                  </h4>
                </div>
                <div
                  class="col-lg-7 col-md-7 col-sm-7 col-xs-12 align-self-center"
                >
                  <div class="form-item-input">
                    <mat-form-field appearance="outline">
                      <input
                        matInput
                        type="text"
                        placeholder="{{ 'pages.placeholders.Enterlastname' | translate }}"
                        formControlName="lastName"
                        required
                      />
                    </mat-form-field>
                    <div *ngIf="f.lastName.touched && f.lastName.invalid">
                      <div *ngIf="f.lastName.errors.required">
                        <mat-hint class="text-danger ms-2">
                          <span translate>pages.newRetailer.lastnameisrequired</span></mat-hint
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div class="row g-0">
                <div
                  class="col-lg-5 col-md-5 col-sm-5 col-xs-12 align-self-center"
                >
                  <h4 class="form-item-label" translate>
                    pages.newRetailer.userName<span class="required">*</span>
                  </h4>
                </div>
                <div
                  class="col-lg-7 col-md-7 col-sm-7 col-xs-12 align-self-center"
                >
                  <div class="form-item-input">
                    <mat-form-field appearance="outline">
                      <input
                        matInput
                        type="text"
                        placeholder="Enter Username"
                        formControlName="userName"
                        readonly
                        required
                      />
                    </mat-form-field>
                    <div *ngIf="f.userName.touched && f.userName.invalid">
                      <div *ngIf="f.userName.errors.required">
                        <mat-hint class="text-danger ms-2">
                          <span translate class="translate">pages.newRetailer.usernameisrequired</span></mat-hint
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div class="row g-0">
                <div
                  class="col-lg-5 col-md-5 col-sm-5 col-xs-12 align-self-center"
                >
                  <h4 class="form-item-label" translate>
                    pages.newRetailer.emailInput<span class="required">*</span>
                  </h4>
                </div>
                <div
                  class="col-lg-7 col-md-7 col-sm-7 col-xs-12 align-self-center"
                >
                  <div class="form-item-input">
                    <mat-form-field appearance="outline">
                      <input
                        matInput
                        type="text"
                        placeholder="{{ 'pages.placeholders.EnterEmail' | translate }} "
                        formControlName="email"
                      />
                    </mat-form-field>
                    <div *ngIf="f.email.touched && f.email.invalid">
                      <div *ngIf="f.email.errors.required">
                        <mat-hint class="text-danger ms-2">
                          <span translate class="translate">pages.newRetailer.emailIdisrequired</span></mat-hint
                        >
                      </div>

                      <div *ngIf="f.email.errors.pattern">
                        <mat-hint class="text-danger ms-2">
                          <span translate class="translate">pages.newRetailer.invalidformat</span></mat-hint
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div class="row g-0">
                <div
                  class="col-lg-5 col-md-5 col-sm-5 col-xs-12 align-self-center"
                >
                  <h4 class="form-item-label" translate>
                    pages.newRetailer.mobileNumber<span class="required">*</span>
                  </h4>
                </div>
                <div
                  class="col-lg-7 col-md-7 col-sm-7 col-xs-12 align-self-center"
                >
                  <div class="form-item-input">
                    <mat-form-field appearance="outline">
                      <input
                        matInput
                        type="text"
                        [textMask]="{ mask: phone }"
                        placeholder="{{'pages.Creditlinebalance.Entermobilenumber' | translate }}"
                        formControlName="mobileNumber"
                      />
                    </mat-form-field>
                    <div *ngIf="f.mobileNumber.touched && f.mobileNumber.invalid">
                      <div *ngIf="f.mobileNumber.errors.required">
                        <mat-hint class="text-danger ms-2">
                          <span translate class="translate">pages.newRetailer.mobileNumberisrequired</span></mat-hint
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div class="row g-0">
                <div
                  class="col-lg-5 col-md-5 col-sm-5 col-xs-12 align-self-center"
                >
                  <h4 class="form-item-label" translate>
                    pages.newRetailer.password<span class="required">*</span>
                  </h4>
                </div>
                <div
                  class="col-lg-7 col-md-7 col-sm-7 col-xs-12 align-self-center"
                >
                  <div class="form-item-input">
                    <mat-form-field appearance="outline">
                      <input
                        formControlName="password"
                        matInput
                        [type]="hide ? 'password' : 'text'"
                        placeholder="Password"
                        readonly
                      />
                      <!--<button
                        mat-icon-button
                        type="button"
                        matSuffix
                        (click)="hide = !hide"
                        [attr.aria-label]="'Hide password'"
                        [attr.aria-pressed]="hide"
                      >
                        <mat-icon>{{
                          hide ? "visibility_off" : "visibility"
                        }}</mat-icon>
                      </button> -->
                    </mat-form-field>
                    <mat-hint
                      class="cur-point text-underline"
                      (click)="onUpdatePassword($event)"
                    >
                    <span translate class="translate">pages.newRetailer.updatePassword</span>
                    </mat-hint>
                    <!-- <div *ngIf="f.password.touched && f.password.invalid">
                      <div *ngIf="f.password.errors.required">
                        <mat-hint class="text-danger ms-2">
                          Password is required.</mat-hint
                        >
                      </div>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
          </div>
        </div>
        <hr />
      
        <div class="content-details-blk px-0">
          <div class="row">
            <div class="col-xxl-3 col-xl-3 col-lg-3 col-sm-6 col-xs-12">
              <h5 class="content-label-each text-capitalize text-start mb-4" translate>
                pages.newRetailer.preferredLanguage
              </h5>
              <div class="content-details-blk px-0">
                <h4 class="form-item-label" translate>
                  pages.newRetailer.changePreferredLanguage<span class="required">*</span>
                    </h4>
                     <div class="form-item-input w-75">
                         <mat-form-field appearance="outline">
                        <mat-select formControlName="preferredLanguage"  [(value)]="selectedlanguage" placeholder="Select Language">
                            <mat-option value="en">English</mat-option>
                            <mat-option value="es">Español</mat-option>
                        </mat-select>
                        </mat-form-field>
                        <div *ngIf="f.preferredLanguage.touched && f.preferredLanguage.invalid">
                            <div *ngIf="f.preferredLanguage.errors.required">
                                <mat-hint class="text-danger ms-2">
                                  <span translate class="translate">pages.newRetailer.languageisrequired</span>></mat-hint
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
              <div class="col-xxl-9 col-xl-9 col-lg-9 col-sm-6 col-xs-12">
                <h5 class="content-label-each text-capitalize text-start mb-4" translate>
                  pages.newRetailer.address
                </h5>
                  <div class="row">
                      <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
                      <h4 class="form-item-label" translate>
                          pages.newRetailer.address<span class="required">*</span>
                      </h4>
                      </div>
                      <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center mb-3">
                      <div class="form-item-input ">
                          <mat-form-field appearance="outline" class="w-100">
                          <textarea
                              matInput
                              
                              formControlName="address1"
                              placeholder="{{'pages.AddProviders.Enteraddress' | translate }}"
                          ></textarea>

                          </mat-form-field>
                          <div *ngIf="f.address1.touched && f.address1.invalid">
                          <div *ngIf="f.address1.errors.required">
                              <mat-hint class="text-danger ms-2">
                                <span translate class="translate">pages.newRetailer.addressisrequired</span></mat-hint
                              >
                          </div>
                          </div>
                      </div>
                      </div>
                      <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
                      <h4 class="form-item-label" translate>
                          pages.newRetailer.city<span class="required">*</span>
                      </h4>
                      </div>
                      <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
                      <div class="form-item-input">
                          <mat-form-field appearance="outline">
                          <input
                              matInput
                              required
                              formControlName="city"
                              placeholder="{{'pages.AddProviders.Entercity' | translate }}"
                          />
                          </mat-form-field>
                          <div *ngIf="f.city.touched && f.city.invalid">
                          <div *ngIf="f.city.errors.required">
                              <mat-hint class="text-danger ms-2"><span translate class="translate">pages.newRetailer.cityisrequired</span></mat-hint>
                          </div>
                          </div>
                      </div>
                      </div>
                  </div>
                  <div class="row ">
                      <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
                      <h4 class="form-item-label" translate>
                          pages.newRetailer.state<span class="required">*</span>
                      </h4>
                      </div>
                      <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
                      <div class="form-item-input">
                          <mat-form-field appearance="outline">
                          <mat-select formControlName="state" [(value)]="selectedstate" placeholder="{{'pages.AddProviders.Selectstate' | translate }}">
                              <mat-option *ngFor="let state of usStateZips" [value]="state">
                              {{ state }}
                              </mat-option>
                          </mat-select>
                          </mat-form-field>
                          <div *ngIf="f.state.touched && f.state.invalid">
                              <div *ngIf="f.state.errors.required">
                                  <mat-hint class="text-danger ms-2">
                                    <span translate class="translate">pages.newRetailer.stateisrequired</span></mat-hint
                                  >
                              </div>
                          </div>
                      </div>
                      </div>
                      <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
                      <h4 class="form-item-label" translate>
                          pages.newRetailer.zipCode<span class="required">*</span>
                      </h4>
                      </div>
                      <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
                      <div class="form-item-input">
                          <mat-form-field appearance="outline">
                          <input
                              matInput
                              required
                              maxlength="5"
                              minlength="5"
                              type="text"
                              placeholder="Enter ZIP"
                              formControlName="zipcode"
                          />
                          </mat-form-field>
                          <div *ngIf="f.zipcode.touched && f.zipcode.invalid">
                          <div *ngIf="f.zipcode.errors.required">
                              <mat-hint class="text-danger ms-2"> {{ 'pages.placeholders.ZIPisrequired' | translate }}</mat-hint>
                          </div>
                          <div *ngIf="f.zipcode.errors.pattern">
                              <mat-hint class="text-danger ms-2"
                              ><span translate class="translate">pages.newRetailer.invalidZIPformat</span></mat-hint
                              >
                          </div>
                          </div>
                      </div>
                      </div>
                      
                  </div>
              </div>
          </div>
        </div>
         <hr />
     
        <div class="form-footer">
            <button mat-raised-button 
            type="submit" 
            color="primary" 
            [disabled]="checkSubmitDisplayed()"><span translate class="translate">pages.newRetailer.saveChanges</span></button>
        </div>
    </form>
  </div>
</div>
